export default "__VITE_ASSET__DI73k35$__"